import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChat1Fill = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22H4C2.89543 22 2 21.1046 2 20V12C2 6.47715 6.47715 2 12 2ZM12 14H9C8.44772 14 8 14.4477 8 15C8 15.5523 8.44772 16 9 16H12C12.5523 16 13 15.5523 13 15C13 14.4477 12.5523 14 12 14ZM15 10H9C8.44772 10 8 10.4477 8 11C8 11.5128 8.38604 11.9355 8.88338 11.9933L9 12H15C15.5523 12 16 11.5523 16 11C16 10.4872 15.614 10.0645 15.1166 10.0067L15 10Z" })
});
export default SvgChat1Fill;
